<template>
  <div class="message">
    {{ `Your next session begins in ${timeLeftString}.` }}
  </div>
  <!-- <div v-if="sessionIsMatched" class="message">
    {{ `Your next session begins in ${timeLeftString}.` }}
  </div>
  <div v-else class="message">
    {{ `Your next session begins in ${timeLeftString}. No partner yet...` }}
  </div> -->
</template>


<script>
export default {
  name: "MoreThanTenToSession",
  props: ["sessionIsMatched", "minutesToNextSession"],
  computed: {
    timeLeftString() {
      if (this.minutesToNextSession < 60) {
        return String(this.minutesToNextSession) + " minutes";
      } else if (this.minutesToNextSession < 120) {
        return "1 hour";
      } else if (this.minutesToNextSession < 1440) {
        return String(Math.floor(this.minutesToNextSession / 60)) + " hours";
      } else if (this.minutesToNextSession < 2880) {
        return "1 day";
      } else {
        return String(Math.floor(this.minutesToNextSession / 1440)) + " days";
      }
    },
  },
};
</script>
